module.exports = __webpack_public_path__ + "static/media/header_replay.cc04b79d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_replay.jpg
// module id = 198
// module chunks = 1